import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteDoctorRes;
export const DeleteDoctorTodo = createAsyncThunk('DeleteDoctor', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `admin/doctor/${id}`,
            params: {
                "company_id":localStorage.getItem('companyId')
          },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteDoctorRes = res.data

    } catch (error) {
        return DeleteDoctorRes = error.response.data
    }
})
